import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { provideLazyLeafletGetter } from '../../leaflet/lazy-leaflet.provider';
import { SmartGridModule } from '../../smart-grid/smart-grid.module';
import { TablesModule } from '../../tables/tables.module';
import { DataSourceFavouritesModule } from '../data-source-favourites/data-source-favourites.module';
import { PropertyComponent } from './components/properties/property/property.component';
import { MajorPropertiesViewTileComponent } from './components/tiles/major-properties-view-tile/major-properties-view-tile.component';
import { ParagraphViewTileComponent } from './components/tiles/paragraph-view-tile/paragraph-view-tile.component';
import { PropertiesViewTileComponent } from './components/tiles/properties-view-tile/properties-view-tile.component';
import { RailMapViewTileComponent } from './components/tiles/rail-map-view-tile/rail-map-view-tile.component';
import { ViewTileWrapperComponent } from './components/tiles/view-tile-wrapper/view-tile-wrapper.component';
import { DataSourceItemViewComponent } from './components/views/data-source-item-view/data-source-item-view.component';
import { DataSourceItemViewsService } from './services/data-source-item-views.service';

@NgModule({
  imports: [CommonModule, SharedModule, SmartGridModule, TablesModule, DataSourceFavouritesModule],
  declarations: [
    DataSourceItemViewComponent,
    PropertiesViewTileComponent,
    ViewTileWrapperComponent,
    MajorPropertiesViewTileComponent,
    ParagraphViewTileComponent,
    RailMapViewTileComponent,
    PropertyComponent,
  ],
  providers: [DataSourceItemViewsService, provideLazyLeafletGetter()],
  exports: [DataSourceItemViewComponent],
})
export class DataSourceItemViewsModule {}
